import { Column } from 'devextreme-react/data-grid';
import { GridRowAction, GridRowActionButton } from './GridRowActionButton';

interface BfiActionColumnParameters<T = {}> {
    tableRowActions: GridRowAction<T>[];
}

export function BfiActionColumn<T>(props: BfiActionColumnParameters<T>) {
    return (
        <Column
            alignment='center'
            width={50}
            allowSorting={false}
            allowResizing={false}
            type='actions'
            fixed={true}
            fixedPosition={'right'}
            cellRender={(cellData) => (
                <GridRowActionButton<T>
                    id={cellData.key}
                    data={cellData.data}
                    tableRowActions={props.tableRowActions}
                />
            )}
        />
    );
}
